export default __webpack_public_path__ + "static/Plate_2x2_Nougat_RGB-9c903bfdb744817727c249d73e2806ae.svg";